import React from "react";

const AboutCreatyea = () => {
  return (
    <section className="featured-section featured-features-section">
      <div className="header-section">
        <h2>About Creatyea</h2>
      </div>
      <div className="body-section">
        <div className="featured-feature">
          <div className="featured-feature-image-1"></div>
          <div className="text-data">
            <h3>Innovation for Sustainability</h3>
            <p>
              Creatyea pioneers sustainable electronics daily, offering
              integrated circuits and passive components that pave the way for
              eco-friendly tech solutions, ensuring a greener future for all.
            </p>
          </div>
        </div>
        <div className="featured-feature">
          <div className="featured-feature-image-2"></div>
          <div className="text-data">
            <h3>Environmental Advocacy & Impact</h3>
            <p>
              Creatyea actively addresses environmental concerns, complying with
              RoHS standards and driving positive global change, fostering a
              climate-conscious approach in all aspects of our operations.
            </p>
          </div>
        </div>
        <div className="featured-feature">
          <div className="featured-feature-image-3"></div>
          <div className="text-data">
            <h3>Join Our Visionary Team</h3>
            <p>
              At Creatyea, our diverse and inclusive community of professionals
              shares a passion for enhancing everyday life sustainably. Each
              member brings unique value, contributing to our shared vision for
              a better future.
            </p>
          </div>
        </div>
        <div className="featured-feature">
          <div className="featured-feature-image-4"></div>
          <div className="text-data">
            <h3>Discover Exceptional Electronics</h3>
            <p>
              Explore Creatyea's extensive product range, delivering unmatched
              quality globally. From cutting-edge components to seamless
              distribution, our offerings redefine the standards of excellence
              in the electronics industry.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutCreatyea;
